import { render, staticRenderFns } from "./BuildForSection.vue?vue&type=template&id=2dabbc95&scoped=true"
import script from "./BuildForSection.vue?vue&type=script&lang=js"
export * from "./BuildForSection.vue?vue&type=script&lang=js"
import style0 from "./BuildForSection.vue?vue&type=style&index=0&id=2dabbc95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabbc95",
  null
  
)

export default component.exports